// extracted by mini-css-extract-plugin
export var colorBgInvertedPrimaryOne = "#f2f8ff";
export var colorBgInvertedPrimaryTwo = "#e9f3ff";